import { Box } from '@chakra-ui/react';

import styled, { keyframes } from 'styled-components';

const SkeletonLoading = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const Skeleton = styled(Box)`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: ${SkeletonLoading} 1.5s infinite;
`;

export function Card({ children, ...rest }) {
  return (
    <Box border="1px solid #C7C7C7" bgColor="white" px={4} position="relative" {...rest}>
      {rest.isLoading && (
        <Skeleton
          position="absolute"
          top="0"
          left="0"
          w="100%"
          h="100%"
          bgColor="white"
          color="#2D2D2D"
          px={2}
          zIndex="2"
        />
      )}

      {children}
    </Box>
  );
}
